import Vue from 'vue';
import LazyRoute from 'framework/components/lazy-route/lazy-route';
import templates from 'framework/lazy-route/page-templates';

/**
 * Create a lazy wrapper container to load asynchronously all the templates
 * @param {Promise} component - promise that will render asynchronously our template
 * @return {Vue.Component} a vue lazy page wrapper component
 */
export function createLazyWrapper(component) {
    return Vue.component('LazyPageWrapper', {
        functional: true,
        render(h) {
            return h(LazyRoute, {
                props: { component },
            });
        },
    });
}

/**
 * Preprocess a route record coming from the server as these must be JSON compliant data
 * @param {IRouteRecord} record - The route record coming from the server
 * @return {IRouteRecord} The transformed record
 */
export function prepareRecord(record) {
    const { redirect, alias, component } = record;

    if (!redirect && !alias) {
        record.component = createLazyWrapper(templates[component]);
    }

    return record;
}
